/* eslint-disable react-refresh/only-export-components */
import { styled, Typography, TypographyProps } from '@mui/material';

export interface ClampedMultilineProps extends TypographyProps {
  lines?: number;
}

export const ClampedMultilineStyled = styled(Typography)<ClampedMultilineProps>(({ lines }) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: lines,
}));

export const ClampedMultiline = (props: ClampedMultilineProps) => {
  // Enforce inheritance of variant and color when wrapped in other Typography already
  return <ClampedMultilineStyled component={'span'} {...props} />;
};
